<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <!-- 入口 -->
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import { AppDeviceEnquire } from "@/utils/mixin";
export default {
  mixins: [AppDeviceEnquire],
  data() {
    return {
      locale: zhCN
    };
  },
  mounted() {}
};
</script>
<style lang="less">
.a-action {
  padding: 0 5px;
}
</style>
